import { Resolution } from "@/types/common";
import { ModelConfigKey, ModelPreset } from "@/types/modelConfig";
import { storageManager } from "./storageManager";

const UI_STORAGE_PREFIX = "ui";
const getChatWidthKey = () => `${UI_STORAGE_PREFIX}::chat_width`;
const getAspectRatioKey = () => `${UI_STORAGE_PREFIX}::chat_aspect_ratio`;
const getResolutionKey = () => `${UI_STORAGE_PREFIX}::resolution`;
const getModelPresetKey = () => `${UI_STORAGE_PREFIX}::model_preset`;
const getCustomModelConfigKey = () => `${UI_STORAGE_PREFIX}::custom_model_config`;

export async function loadChatWidth(): Promise<number | null> {
  const stored = await storageManager.get<number>(getChatWidthKey());
  return typeof stored === "number" ? stored : null;
}

export async function persistChatWidth(width: number) {
  await storageManager.set(getChatWidthKey(), width);
}

export async function loadAspectRatio(): Promise<string | null> {
  const stored = await storageManager.get<string>(getAspectRatioKey());
  return typeof stored === "string" ? stored : null;
}

export async function persistAspectRatio(value: string) {
  await storageManager.set(getAspectRatioKey(), value);
}

export async function loadResolution(): Promise<Resolution | null> {
  const stored = await storageManager.get<Resolution>(getResolutionKey());
  return stored === Resolution.HD || stored === Resolution.FULL_HD
    ? stored
    : null;
}

export async function persistResolution(value: Resolution) {
  await storageManager.set(getResolutionKey(), value);
}

export async function loadModelPreset(): Promise<ModelPreset | null> {
  const stored = await storageManager.get<ModelPreset>(getModelPresetKey());
  return stored === "studio" || stored === "lite" || stored === "custom"
    ? stored
    : null;
}

export async function persistModelPreset(value: ModelPreset) {
  await storageManager.set(getModelPresetKey(), value);
}

export async function loadCustomModelConfig(): Promise<Partial<
  Record<ModelConfigKey, string>
> | null> {
  const stored = await storageManager.get<
    Partial<Record<ModelConfigKey, string>>
  >(getCustomModelConfigKey());
  return stored && typeof stored === "object" ? stored : null;
}

export async function persistCustomModelConfig(
  config: Partial<Record<ModelConfigKey, string>>
) {
  await storageManager.set(getCustomModelConfigKey(), config);
}
